import React from 'react';
import { ChevronLeftIcon, ChevronRightIcon } from '@heroicons/react/24/outline';

interface FormNavigationProps {
  currentStep: number;
  totalSteps: number;
  onNext: () => void;
  onBack: () => void;
  onCancel: () => void;
  nextLabel?: string;
  isSubmitting?: boolean;
  canGoNext?: boolean;
  validationMessage?: string;
}

const FormNavigation: React.FC<FormNavigationProps> = ({
  currentStep,
  totalSteps,
  onNext,
  onBack,
  onCancel,
  nextLabel = 'Next',
  isSubmitting = false,
  canGoNext = true,
  validationMessage
}) => {
  return (
    <div className="space-y-4 mt-12 pt-6 border-t border-gray-200">
      {/* Validation message */}
      {validationMessage && !canGoNext && (
        <div className="text-center">
          <span className="text-sm text-red-600">{validationMessage}</span>
        </div>
      )}
      
      {/* Navigation buttons */}
      <div className="flex justify-between">
        {/* Left side buttons */}
        <div className="flex space-x-4">
          <button
            type="button"
            onClick={onCancel}
            className="px-4 py-2 text-sm font-medium text-gray-700 bg-white border border-gray-300 rounded-md hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-primary-500"
          >
            Cancel
          </button>
          
          {currentStep > 1 && (
            <button
              type="button"
              onClick={onBack}
              className="inline-flex items-center px-4 py-2 text-sm font-medium text-gray-700 bg-white border border-gray-300 rounded-md hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-primary-500"
            >
              <ChevronLeftIcon className="w-4 h-4 mr-2" />
              Previous
            </button>
          )}
        </div>

        {/* Right side button */}
        <button
          type="button"
          onClick={onNext}
          disabled={!canGoNext || isSubmitting}
          className={`inline-flex items-center px-4 py-2 text-sm font-medium text-white rounded-md focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-primary-500 ${
            canGoNext && !isSubmitting
              ? 'bg-primary-600 hover:bg-primary-700'
              : 'bg-gray-400 cursor-not-allowed'
          }`}
        >
          {isSubmitting ? 'Processing...' : nextLabel}
          {!isSubmitting && currentStep < totalSteps && (
            <ChevronRightIcon className="w-4 h-4 ml-2" />
          )}
        </button>
      </div>
    </div>
  );
};

export default FormNavigation;
